import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  Unit_instanceat14thlj150z as Unit_instance,
  StringCompanionObject_instance1kavzb69ik84p as StringCompanionObject_instance,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  emptyList1g2z5xcrvp2zy as emptyList,
  LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  zip2suipyqmdw72q as zip,
  toMap1vec9topfei08 as toMap,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  toString1pkumu07cwy4m as toString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  asList2ho2pewtsfvv as asList,
  KtMap140uvy3s5zad8 as KtMap,
  isInterface3d6p8outrmvmk as isInterface,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  captureStack1fzi4aczwc4hg as captureStack,
  Iterable1y3qizuf89iou as Iterable,
  isBlank1dvkhjjvox3p0 as isBlank,
  equals2au1ep9vhcato as equals,
  toList383f556t1dixk as toList,
  ArrayList3it5z8td81qkl as ArrayList,
  HashSet2dzve9y63nf0v as HashSet,
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  copyToArray2j022khrow2yi as copyToArray,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
  withIndex3s8q7w1g0hyfn as withIndex,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  to2cs3ny02qtbcb as to,
  lazy2hsh8ze7j6ikd as lazy_0,
  contentEqualsaf55p28mnw74 as contentEquals,
  until1jbpn0z3f8lbg as until,
  joinToString1cxrrlmo0chqs as joinToString,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  hashCodeq5arwsb9dgti as hashCode,
  KtList3hktaavzmj137 as KtList,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  KtSetjrjc7fhfd6b9 as KtSet,
  Collection1k04j3hzsbod0 as Collection,
  longArray288a0fctlmjmj as longArray,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_lastIndex1y2f6o9u8hnf7 as get_lastIndex,
  Long2qws0ah9gnpki as Long,
  countTrailingZeroBits1k55x07cygoff as countTrailingZeroBits,
  HashMap1a0ld5kgwhmhv as HashMap,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  booleanArray2jdug9b51huk7 as booleanArray,
  emptyMapr06gerzljqtm as emptyMap,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  ByteCompanionObject_instance1hjbskmeqhwpn as ByteCompanionObject_instance,
  isByteArray4nnzfn1x4o3w as isByteArray,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  copyOfwy6h3t5vzqpl as copyOf,
  toString30pk9tzaqopn as toString_0,
  Entry2xmjmyutzoq3p as Entry,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
  get_indicesc04v40g017hw as get_indices,
  get_indices377latqcai313 as get_indices_0,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class SerializationStrategy {}
class DeserializationStrategy {}
class KSerializer {}
class _no_name_provided__qut3iv {
  constructor($this) {
    this.ncu_1 = $this;
  }
  ocu() {
    return this.ncu_1.a1();
  }
  pcu(element) {
    // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
    return element.r1().tct().qcu();
  }
  rcu(element) {
    return this.pcu((element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class AbstractPolymorphicSerializer {
  static tcu() {
    return createThis(this);
  }
  vcu(encoder, value) {
    var actualSerializer = findPolymorphicSerializer(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.tct();
    var composite = encoder.gcx(descriptor);
    // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.serialize.<anonymous>' call
    composite.ocx(this.tct(), 0, actualSerializer.tct().qcu());
    var tmp = this.tct();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$0 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.pcx(tmp, 1, tmp$ret$0, value);
    composite.qcw(descriptor);
  }
  uct(encoder, value) {
    return this.vcu(encoder, !(value == null) ? value : THROW_CCE());
  }
  vct(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.tct();
    var composite = decoder.gcx(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>' call
      var klassName = null;
      var value = null;
      if (composite.rcw()) {
        tmp$ret$0 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.scw(this.tct());
        switch (index) {
          case -1:
            break mainLoop;
          case 0:
            klassName = composite.ycw(this.tct(), index);
            break;
          case 1:
            var tmp$ret$2;
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              var value_0 = klassName;
              // Inline function 'kotlin.contracts.contract' call
              if (value_0 == null) {
                // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
                var message = 'Cannot read polymorphic value before its type token';
                throw IllegalArgumentException.l(toString(message));
              } else {
                tmp$ret$2 = value_0;
                break $l$block_0;
              }
            }

            klassName = tmp$ret$2;
            var serializer = findPolymorphicSerializer_0(this, composite, klassName);
            value = composite.acx(this.tct(), index, serializer);
            break;
          default:
            var tmp0_elvis_lhs = klassName;
            throw SerializationException.bcv('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
        }
      }
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        var value_1 = value;
        // Inline function 'kotlin.contracts.contract' call
        if (value_1 == null) {
          // Inline function 'kotlinx.serialization.internal.AbstractPolymorphicSerializer.deserialize.<anonymous>.<anonymous>' call
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException.l(toString(message_0));
        } else {
          tmp$ret$4 = value_1;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$0 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$0;
    composite.qcw(descriptor);
    return result;
  }
  yct(decoder, klassName) {
    return decoder.pcw().qcx(this.xct(), klassName);
  }
  wct(encoder, value) {
    return encoder.pcw().rcx(this.xct(), value);
  }
}
class SealedClassSerializer extends AbstractPolymorphicSerializer {
  static scu(serialName, baseClass, subclasses, subclassSerializers) {
    var $this = this.tcu();
    $this.zct_1 = baseClass;
    $this.acu_1 = emptyList();
    var tmp = $this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.bcu_1 = lazy(tmp_0, SealedClassSerializer$descriptor$delegate$lambda(serialName, $this));
    if (!(subclasses.length === subclassSerializers.length)) {
      throw IllegalArgumentException.l('All subclasses of sealed class ' + $this.zct_1.ye() + ' should be marked @Serializable');
    }
    $this.ccu_1 = toMap(zip(subclasses, subclassSerializers));
    var tmp_1 = $this;
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.aggregate' call
    // Inline function 'kotlin.collections.groupingBy' call
    var this_0 = $this.ccu_1.p1();
    // Inline function 'kotlin.collections.aggregateTo' call
    var this_1 = new _no_name_provided__qut3iv(this_0);
    // Inline function 'kotlin.collections.mutableMapOf' call
    var destination = LinkedHashMap.bc();
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this_1.ocu();
    while (tmp0_iterator.b1()) {
      var e = tmp0_iterator.c1();
      var key = this_1.rcu(e);
      var accumulator = destination.c3(key);
      // Inline function 'kotlin.collections.set' call
      // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
      accumulator == null && !destination.a3(key);
      if (!(accumulator == null)) {
        // Inline function 'kotlin.error' call
        var message = "Multiple sealed subclasses of '" + toString($this.zct_1) + "' have the same serial name '" + key + "':" + (" '" + toString(accumulator.q1()) + "', '" + toString(e.q1()) + "'");
        throw IllegalStateException.w4(toString(message));
      }
      destination.e3(key, e);
    }
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_0 = LinkedHashMap.cc(mapCapacity(destination.e1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var tmp0_iterator_0 = destination.p1().a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'kotlin.collections.mapValuesTo.<anonymous>' call
      var tmp_2 = element.q1();
      // Inline function 'kotlinx.serialization.SealedClassSerializer.<anonymous>' call
      var tmp$ret$7 = element.r1().r1();
      destination_0.e3(tmp_2, tmp$ret$7);
    }
    tmp_1.dcu_1 = destination_0;
    return $this;
  }
  xct() {
    return this.zct_1;
  }
  static ucu(serialName, baseClass, subclasses, subclassSerializers, classAnnotations) {
    var $this = this.scu(serialName, baseClass, subclasses, subclassSerializers);
    $this.acu_1 = asList(classAnnotations);
    return $this;
  }
  tct() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.bcu_1;
    descriptor$factory();
    return this_0.r1();
  }
  yct(decoder, klassName) {
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.dcu_1;
    var tmp0_elvis_lhs = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).c3(klassName);
    return tmp0_elvis_lhs == null ? super.yct(decoder, klassName) : tmp0_elvis_lhs;
  }
  wct(encoder, value) {
    var tmp0_elvis_lhs = this.ccu_1.c3(getKClassFromExpression(value));
    var tmp1_safe_receiver = tmp0_elvis_lhs == null ? super.wct(encoder, value) : tmp0_elvis_lhs;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, SerializationStrategy) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
}
class SerializationException extends IllegalArgumentException {
  static acv() {
    var $this = this.ud();
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
  static bcv(message) {
    var $this = this.l(message);
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
  static ccv(message, cause) {
    var $this = this.wd(message, cause);
    init_kotlinx_serialization_SerializationException($this);
    return $this;
  }
}
class UnknownFieldException extends SerializationException {
  static icv(message) {
    var $this = this.bcv(message);
    captureStack($this, $this.hcv_1);
    return $this;
  }
  static jcv(index) {
    return this.icv('An unknown field for index ' + index);
  }
}
class MissingFieldException extends SerializationException {
  static qcv(missingFields, message, cause) {
    var $this = this.ccv(message, cause);
    captureStack($this, $this.pcv_1);
    $this.ocv_1 = missingFields;
    return $this;
  }
  static rcv(missingFields, serialName) {
    return this.qcv(missingFields, missingFields.e1() === 1 ? "Field '" + missingFields.d1(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing", null);
  }
}
class SerialDescriptor {}
function get_isNullable() {
  return false;
}
class elementDescriptors$1 {
  constructor($this_elementDescriptors) {
    this.acw_1 = $this_elementDescriptors;
    this.zcv_1 = $this_elementDescriptors.ucv();
  }
  b1() {
    return this.zcv_1 > 0;
  }
  c1() {
    var tmp = this.acw_1.ucv();
    var tmp1 = this.zcv_1;
    this.zcv_1 = tmp1 - 1 | 0;
    return this.acw_1.xcv(tmp - tmp1 | 0);
  }
}
class _no_name_provided__qut3iv_0 {
  constructor($this_elementDescriptors) {
    this.bcw_1 = $this_elementDescriptors;
  }
  a1() {
    // Inline function 'kotlinx.serialization.descriptors.<get-elementDescriptors>.<anonymous>' call
    return new elementDescriptors$1(this.bcw_1);
  }
}
class ClassSerialDescriptorBuilder {
  constructor(serialName) {
    this.ecu_1 = serialName;
    this.fcu_1 = false;
    this.gcu_1 = emptyList();
    this.hcu_1 = ArrayList.h1();
    this.icu_1 = HashSet.da();
    this.jcu_1 = ArrayList.h1();
    this.kcu_1 = ArrayList.h1();
    this.lcu_1 = ArrayList.h1();
  }
  ccw(elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.icu_1.h(elementName)) {
      // Inline function 'kotlinx.serialization.descriptors.ClassSerialDescriptorBuilder.element.<anonymous>' call
      var message = "Element with name '" + elementName + "' is already registered in " + this.ecu_1;
      throw IllegalArgumentException.l(toString(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.hcu_1.h(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.jcu_1.h(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.kcu_1.h(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.lcu_1.h(isOptional);
  }
  mcu(elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.ccw(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.ccw.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  }
}
class SerialDescriptorImpl {
  constructor(serialName, kind, elementsCount, typeParameters, builder) {
    this.dcw_1 = serialName;
    this.ecw_1 = kind;
    this.fcw_1 = elementsCount;
    this.gcw_1 = builder.gcu_1;
    this.hcw_1 = toHashSet(builder.hcu_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.hcu_1;
    tmp.icw_1 = copyToArray(this_0);
    this.jcw_1 = compactArray(builder.jcu_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.kcu_1;
    tmp_0.kcw_1 = copyToArray(this_1);
    this.lcw_1 = toBooleanArray(builder.lcu_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.icw_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator = this_2.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.name2Index.<anonymous>' call
      var tmp$ret$2 = to(item.zk_1, item.yk_1);
      destination.h(tmp$ret$2);
    }
    tmp_1.mcw_1 = toMap(destination);
    this.ncw_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.ocw_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  qcu() {
    return this.dcw_1;
  }
  scv() {
    return this.ecw_1;
  }
  ucv() {
    return this.fcw_1;
  }
  vcv(index) {
    return getChecked(this.icw_1, index);
  }
  wcv(index) {
    return getChecked(this.kcw_1, index);
  }
  xcv(index) {
    return getChecked(this.jcw_1, index);
  }
  ycv(index) {
    return getChecked_0(this.lcw_1, index);
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.qcu() === other.qcu())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.descriptors.SerialDescriptorImpl.equals.<anonymous>' call
      if (!contentEquals(this.ncw_1, other.ncw_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ucv() === other.ucv())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.ucv();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.xcv(index).qcu() === other.xcv(index).qcu())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.xcv(index).scv(), other.xcv(index).scv())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  hashCode() {
    return _get__hashCode__tgwhef(this);
  }
  toString() {
    var tmp = until(0, this.fcw_1);
    var tmp_0 = this.dcw_1 + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, SerialDescriptorImpl$toString$lambda(this));
  }
}
class SerialKind {
  toString() {
    return ensureNotNull(getKClassFromExpression(this).ye());
  }
  hashCode() {
    return getStringHashCode(this.toString());
  }
}
class CONTEXTUAL extends SerialKind {
  constructor() {
    CONTEXTUAL_instance = null;
    super();
    CONTEXTUAL_instance = this;
  }
}
class PrimitiveKind extends SerialKind {}
class BOOLEAN extends PrimitiveKind {
  constructor() {
    BOOLEAN_instance = null;
    super();
    BOOLEAN_instance = this;
  }
}
class BYTE extends PrimitiveKind {
  constructor() {
    BYTE_instance = null;
    super();
    BYTE_instance = this;
  }
}
class INT extends PrimitiveKind {
  constructor() {
    INT_instance = null;
    super();
    INT_instance = this;
  }
}
class FLOAT extends PrimitiveKind {
  constructor() {
    FLOAT_instance = null;
    super();
    FLOAT_instance = this;
  }
}
class STRING extends PrimitiveKind {
  constructor() {
    STRING_instance = null;
    super();
    STRING_instance = this;
  }
}
class StructureKind extends SerialKind {}
class CLASS extends StructureKind {
  constructor() {
    CLASS_instance = null;
    super();
    CLASS_instance = this;
  }
}
class LIST extends StructureKind {
  constructor() {
    LIST_instance = null;
    super();
    LIST_instance = this;
  }
}
class MAP extends StructureKind {
  constructor() {
    MAP_instance = null;
    super();
    MAP_instance = this;
  }
}
class OBJECT extends StructureKind {
  constructor() {
    OBJECT_instance = null;
    super();
    OBJECT_instance = this;
  }
}
class PolymorphicKind extends SerialKind {}
class SEALED extends PolymorphicKind {
  constructor() {
    SEALED_instance = null;
    super();
    SEALED_instance = this;
  }
}
class CompositeDecoder {}
function decodeSequentially() {
  return false;
}
function decodeCollectionSize(descriptor) {
  return -1;
}
function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
  previousValue = previousValue === VOID ? null : previousValue;
  return $super === VOID ? this.zcw(descriptor, index, deserializer, previousValue) : $super.zcw.call(this, descriptor, index, deserializer, previousValue);
}
class Encoder {}
function beginCollection(descriptor, collectionSize) {
  return this.gcx(descriptor);
}
function encodeSerializableValue(serializer, value) {
  serializer.uct(this, value);
}
class CompositeEncoder {}
function shouldEncodeElementDefault(descriptor, index) {
  return true;
}
class ListLikeDescriptor {
  constructor(elementDescriptor) {
    this.ucx_1 = elementDescriptor;
    this.vcx_1 = 1;
  }
  scv() {
    return LIST_getInstance();
  }
  ucv() {
    return this.vcx_1;
  }
  vcv(index) {
    return index.toString();
  }
  ycv(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.isElementOptional.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.qcu() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return false;
  }
  wcv(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementAnnotations.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.qcu() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return emptyList();
  }
  xcv(index) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(index >= 0)) {
      // Inline function 'kotlinx.serialization.internal.ListLikeDescriptor.getElementDescriptor.<anonymous>' call
      var message = 'Illegal index ' + index + ', ' + this.qcu() + ' expects only non-negative indices';
      throw IllegalArgumentException.l(toString(message));
    }
    return this.ucx_1;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.ucx_1, other.ucx_1) && this.qcu() === other.qcu())
      return true;
    return false;
  }
  hashCode() {
    return imul(hashCode(this.ucx_1), 31) + getStringHashCode(this.qcu()) | 0;
  }
  toString() {
    return this.qcu() + '(' + toString(this.ucx_1) + ')';
  }
}
class ArrayListClassDesc extends ListLikeDescriptor {
  qcu() {
    return 'kotlin.collections.ArrayList';
  }
}
class LinkedHashSetClassDesc extends ListLikeDescriptor {
  qcu() {
    return 'kotlin.collections.LinkedHashSet';
  }
}
class PrimitiveArrayDescriptor extends ListLikeDescriptor {
  constructor(primitive) {
    super(primitive);
    this.acy_1 = primitive.qcu() + 'Array';
  }
  qcu() {
    return this.acy_1;
  }
}
class AbstractCollectionSerializer {
  wcy(decoder, previous) {
    var tmp1_elvis_lhs = previous == null ? null : this.jcy(previous);
    var builder = tmp1_elvis_lhs == null ? this.dcy() : tmp1_elvis_lhs;
    var startIndex = this.fcy(builder);
    var compositeDecoder = decoder.gcx(this.tct());
    if (compositeDecoder.rcw()) {
      this.tcy(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.scw(this.tct());
        if (index === -1)
          break $l$loop;
        this.vcy(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.qcw(this.tct());
    return this.hcy(builder);
  }
  vct(decoder) {
    return this.wcy(decoder, null);
  }
  vcy(decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.ucy(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.ucy.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  }
}
class CollectionLikeSerializer extends AbstractCollectionSerializer {
  constructor(elementSerializer) {
    super();
    this.rcy_1 = elementSerializer;
  }
  scy(encoder, value) {
    var size = this.ecz(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.tct();
    var composite = encoder.hcx(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.serialize.<anonymous>' call
    var iterator = this.fcz(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.pcx(this.tct(), index, this.rcy_1, iterator.c1());
      }
       while (inductionVariable < size);
    composite.qcw(descriptor);
  }
  uct(encoder, value) {
    return this.scy(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  tcy(decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(size >= 0)) {
      // Inline function 'kotlinx.serialization.internal.CollectionLikeSerializer.readAll.<anonymous>' call
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException.l(toString(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.ucy(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  }
  ucy(decoder, index, builder, checkIndex) {
    this.ncy(builder, index, decoder.acx(this.tct(), index, this.rcy_1));
  }
}
class CollectionSerializer extends CollectionLikeSerializer {
  pcy(_this__u8e3s4) {
    return _this__u8e3s4.e1();
  }
  ecz(_this__u8e3s4) {
    return this.pcy((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  qcy(_this__u8e3s4) {
    return _this__u8e3s4.a1();
  }
  fcz(_this__u8e3s4) {
    return this.qcy((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  }
}
class ArrayListSerializer extends CollectionSerializer {
  constructor(element) {
    super(element);
    this.ccy_1 = new ArrayListClassDesc(element.tct());
  }
  tct() {
    return this.ccy_1;
  }
  dcy() {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList.h1();
  }
  ecy(_this__u8e3s4) {
    return _this__u8e3s4.e1();
  }
  fcy(_this__u8e3s4) {
    return this.ecy(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  gcy(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  hcy(_this__u8e3s4) {
    return this.gcy(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  }
  icy(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList.v(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  jcy(_this__u8e3s4) {
    return this.icy((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  kcy(_this__u8e3s4, size) {
    return _this__u8e3s4.v7(size);
  }
  lcy(_this__u8e3s4, size) {
    return this.kcy(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  }
  mcy(_this__u8e3s4, index, element) {
    _this__u8e3s4.x6(index, element);
  }
  ncy(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE();
    return this.mcy(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class LinkedHashSetSerializer extends CollectionSerializer {
  constructor(eSerializer) {
    super(eSerializer);
    this.ycy_1 = new LinkedHashSetClassDesc(eSerializer.tct());
  }
  tct() {
    return this.ycy_1;
  }
  dcy() {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet.j1();
  }
  zcy(_this__u8e3s4) {
    return _this__u8e3s4.e1();
  }
  fcy(_this__u8e3s4) {
    return this.zcy(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  }
  acz(_this__u8e3s4) {
    return _this__u8e3s4;
  }
  hcy(_this__u8e3s4) {
    return this.acz(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  }
  bcz(_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet.k1(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  jcy(_this__u8e3s4) {
    return this.bcz((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  ccz(_this__u8e3s4, size) {
  }
  lcy(_this__u8e3s4, size) {
    return this.ccz(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  }
  dcz(_this__u8e3s4, index, element) {
    _this__u8e3s4.h(element);
  }
  ncy(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE();
    return this.dcz(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
}
class MapLikeSerializer extends AbstractCollectionSerializer {}
class PrimitiveArraySerializer extends CollectionLikeSerializer {
  constructor(primitiveSerializer) {
    super(primitiveSerializer);
    this.hcz_1 = new PrimitiveArrayDescriptor(primitiveSerializer.tct());
  }
  tct() {
    return this.hcz_1;
  }
  icz(_this__u8e3s4) {
    return _this__u8e3s4.jcz();
  }
  fcy(_this__u8e3s4) {
    return this.icz(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  }
  kcz(_this__u8e3s4) {
    return _this__u8e3s4.lcz();
  }
  hcy(_this__u8e3s4) {
    return this.kcz(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  }
  mcz(_this__u8e3s4, size) {
    return _this__u8e3s4.ncz(size);
  }
  lcy(_this__u8e3s4, size) {
    return this.mcz(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  }
  ocz(_this__u8e3s4) {
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException.w4(toString(message));
  }
  fcz(_this__u8e3s4) {
    return this.ocz((_this__u8e3s4 == null ? true : !(_this__u8e3s4 == null)) ? _this__u8e3s4 : THROW_CCE());
  }
  pcz(_this__u8e3s4, index, element) {
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException.w4(toString(message));
  }
  ncy(_this__u8e3s4, index, element) {
    var tmp = _this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE();
    return this.pcz(tmp, index, (element == null ? true : !(element == null)) ? element : THROW_CCE());
  }
  dcy() {
    return this.jcy(this.qcz());
  }
  tcz(encoder, value) {
    var size = this.ecz(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.hcz_1;
    var composite = encoder.hcx(descriptor, size);
    // Inline function 'kotlinx.serialization.internal.PrimitiveArraySerializer.serialize.<anonymous>' call
    this.scz(composite, value, size);
    composite.qcw(descriptor);
  }
  uct(encoder, value) {
    return this.tcz(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  scy(encoder, value) {
    return this.tcz(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  vct(decoder) {
    return this.wcy(decoder, null);
  }
}
class PrimitiveArrayBuilder {
  ucz(requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.jcz() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.ncz(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.ncz.call(this, requiredCapacity);
    }
    return tmp;
  }
}
class Companion {
  constructor() {
    Companion_instance = this;
    this.vcz_1 = longArray(0);
  }
}
class ElementMarker {
  constructor(descriptor, readIfAbsent) {
    Companion_getInstance();
    this.wcz_1 = descriptor;
    this.xcz_1 = readIfAbsent;
    var elementsCount = this.wcz_1.ucv();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = (new Long(-1, -1)).c4(elementsCount);
      }
      tmp.ycz_1 = tmp_0;
      this.zcz_1 = Companion_getInstance().vcz_1;
    } else {
      this.ycz_1 = new Long(0, 0);
      this.zcz_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  ad0(index) {
    if (index < 64) {
      this.ycz_1 = this.ycz_1.g4((new Long(1, 0)).c4(index));
    } else {
      markHigh(this, index);
    }
  }
  bd0() {
    var elementsCount = this.wcz_1.ucv();
    while (!this.ycz_1.equals(new Long(-1, -1))) {
      var index = countTrailingZeroBits(this.ycz_1.b4());
      this.ycz_1 = this.ycz_1.g4((new Long(1, 0)).c4(index));
      if (this.xcz_1(this.wcz_1, index)) {
        return index;
      }
    }
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  }
}
class PluginGeneratedSerialDescriptor {
  constructor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.cd0_1 = serialName;
    this.dd0_1 = generatedSerializer;
    this.ed0_1 = elementsCount;
    this.fd0_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.ed0_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.gd0_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.ed0_1;
    tmp_3.hd0_1 = fillArrayVal(Array(size), null);
    this.id0_1 = null;
    this.jd0_1 = booleanArray(this.ed0_1);
    this.kd0_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.ld0_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.md0_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.nd0_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  qcu() {
    return this.cd0_1;
  }
  ucv() {
    return this.ed0_1;
  }
  scv() {
    return CLASS_getInstance();
  }
  qd0() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.md0_1;
    typeParameterDescriptors$factory();
    return this_0.r1();
  }
  rd0(name, isOptional) {
    this.fd0_1 = this.fd0_1 + 1 | 0;
    this.gd0_1[this.fd0_1] = name;
    this.jd0_1[this.fd0_1] = isOptional;
    this.hd0_1[this.fd0_1] = null;
    if (this.fd0_1 === (this.ed0_1 - 1 | 0)) {
      this.kd0_1 = buildIndices(this);
    }
  }
  sd0(annotation) {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.pushAnnotation.<anonymous>' call
    var it = this.hd0_1[this.fd0_1];
    var tmp;
    if (it == null) {
      var result = ArrayList.w(1);
      this.hd0_1[this.fd0_1] = result;
      tmp = result;
    } else {
      tmp = it;
    }
    var list = tmp;
    list.h(annotation);
  }
  xcv(index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).tct();
  }
  ycv(index) {
    return getChecked_0(this.jd0_1, index);
  }
  wcv(index) {
    var tmp0_elvis_lhs = getChecked(this.hd0_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  }
  vcv(index) {
    return getChecked(this.gd0_1, index);
  }
  equals(other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.qcu() === other.qcu())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.equals.<anonymous>' call
      if (!contentEquals(this.qd0(), other.qd0())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.ucv() === other.ucv())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.ucv();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.xcv(index).qcu() === other.xcv(index).qcu())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.xcv(index).scv(), other.xcv(index).scv())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  hashCode() {
    return _get__hashCode__tgwhef_0(this);
  }
  toString() {
    var tmp = until(0, this.ed0_1);
    var tmp_0 = this.qcu() + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, PluginGeneratedSerialDescriptor$toString$lambda(this));
  }
}
class GeneratedSerializer {}
function typeParametersSerializers() {
  return get_EMPTY_SERIALIZER_ARRAY();
}
class ByteArraySerializer extends PrimitiveArraySerializer {
  constructor() {
    ByteArraySerializer_instance = null;
    super(serializer_0(ByteCompanionObject_instance));
    ByteArraySerializer_instance = this;
  }
  vd0(_this__u8e3s4) {
    return _this__u8e3s4.length;
  }
  ecz(_this__u8e3s4) {
    return this.vd0((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  wd0(_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  }
  jcy(_this__u8e3s4) {
    return this.wd0((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  qcz() {
    return new Int8Array(0);
  }
  xd0(decoder, index, builder, checkIndex) {
    builder.ad1(decoder.vcw(this.hcz_1, index));
  }
  ucy(decoder, index, builder, checkIndex) {
    return this.xd0(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  rcz(decoder, index, builder, checkIndex) {
    return this.xd0(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  }
  bd1(encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.lcx(this.hcz_1, i, content[i]);
      }
       while (inductionVariable < size);
  }
  scz(encoder, content, size) {
    return this.bd1(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  }
}
class ByteArrayBuilder extends PrimitiveArrayBuilder {
  constructor(bufferWithData) {
    super();
    this.yd0_1 = bufferWithData;
    this.zd0_1 = bufferWithData.length;
    this.ncz(10);
  }
  jcz() {
    return this.zd0_1;
  }
  ncz(requiredCapacity) {
    if (this.yd0_1.length < requiredCapacity)
      this.yd0_1 = copyOf(this.yd0_1, coerceAtLeast(requiredCapacity, imul(this.yd0_1.length, 2)));
  }
  ad1(c) {
    this.ucz();
    var tmp = this.yd0_1;
    var tmp1 = this.zd0_1;
    this.zd0_1 = tmp1 + 1 | 0;
    tmp[tmp1] = c;
  }
  lcz() {
    return copyOf(this.yd0_1, this.zd0_1);
  }
}
class StringSerializer {
  constructor() {
    StringSerializer_instance = this;
    this.cd1_1 = new PrimitiveSerialDescriptor('kotlin.String', STRING_getInstance());
  }
  tct() {
    return this.cd1_1;
  }
  dd1(encoder, value) {
    return encoder.fcx(value);
  }
  uct(encoder, value) {
    return this.dd1(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  vct(decoder) {
    return decoder.ed1();
  }
}
class FloatSerializer {
  constructor() {
    FloatSerializer_instance = this;
    this.fd1_1 = new PrimitiveSerialDescriptor('kotlin.Float', FLOAT_getInstance());
  }
  tct() {
    return this.fd1_1;
  }
  gd1(encoder, value) {
    return encoder.ecx(value);
  }
  uct(encoder, value) {
    return this.gd1(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  vct(decoder) {
    return decoder.hd1();
  }
}
class IntSerializer {
  constructor() {
    IntSerializer_instance = this;
    this.id1_1 = new PrimitiveSerialDescriptor('kotlin.Int', INT_getInstance());
  }
  tct() {
    return this.id1_1;
  }
  jd1(encoder, value) {
    return encoder.dcx(value);
  }
  uct(encoder, value) {
    return this.jd1(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  vct(decoder) {
    return decoder.kd1();
  }
}
class ByteSerializer {
  constructor() {
    ByteSerializer_instance = this;
    this.ld1_1 = new PrimitiveSerialDescriptor('kotlin.Byte', BYTE_getInstance());
  }
  tct() {
    return this.ld1_1;
  }
  md1(encoder, value) {
    return encoder.ccx(value);
  }
  uct(encoder, value) {
    return this.md1(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  }
  vct(decoder) {
    return decoder.nd1();
  }
}
class BooleanSerializer {
  constructor() {
    BooleanSerializer_instance = this;
    this.od1_1 = new PrimitiveSerialDescriptor('kotlin.Boolean', BOOLEAN_getInstance());
  }
  tct() {
    return this.od1_1;
  }
  pd1(encoder, value) {
    return encoder.bcx(value);
  }
  uct(encoder, value) {
    return this.pd1(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  }
  vct(decoder) {
    return decoder.qd1();
  }
}
class PrimitiveSerialDescriptor {
  constructor(serialName, kind) {
    this.rd1_1 = serialName;
    this.sd1_1 = kind;
  }
  qcu() {
    return this.rd1_1;
  }
  scv() {
    return this.sd1_1;
  }
  ucv() {
    return 0;
  }
  vcv(index) {
    error(this);
  }
  ycv(index) {
    error(this);
  }
  xcv(index) {
    error(this);
  }
  wcv(index) {
    error(this);
  }
  toString() {
    return 'PrimitiveDescriptor(' + this.rd1_1 + ')';
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor))
      return false;
    if (this.rd1_1 === other.rd1_1 && equals(this.sd1_1, other.sd1_1))
      return true;
    return false;
  }
  hashCode() {
    return getStringHashCode(this.rd1_1) + imul(31, this.sd1_1.hashCode()) | 0;
  }
}
class MapEntry {
  constructor(key, value) {
    this.td1_1 = key;
    this.ud1_1 = value;
  }
  q1() {
    return this.td1_1;
  }
  r1() {
    return this.ud1_1;
  }
  toString() {
    return 'MapEntry(key=' + toString_0(this.td1_1) + ', value=' + toString_0(this.ud1_1) + ')';
  }
  hashCode() {
    var result = this.td1_1 == null ? 0 : hashCode(this.td1_1);
    result = imul(result, 31) + (this.ud1_1 == null ? 0 : hashCode(this.ud1_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    var tmp0_other_with_cast = other instanceof MapEntry ? other : THROW_CCE();
    if (!equals(this.td1_1, tmp0_other_with_cast.td1_1))
      return false;
    if (!equals(this.ud1_1, tmp0_other_with_cast.ud1_1))
      return false;
    return true;
  }
}
class KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    this.dd2_1 = keySerializer;
    this.ed2_1 = valueSerializer;
  }
  fd2(encoder, value) {
    var structuredEncoder = encoder.gcx(this.tct());
    structuredEncoder.pcx(this.tct(), 0, this.dd2_1, this.zd1(value));
    structuredEncoder.pcx(this.tct(), 1, this.ed2_1, this.bd2(value));
    structuredEncoder.qcw(this.tct());
  }
  uct(encoder, value) {
    return this.fd2(encoder, (value == null ? true : !(value == null)) ? value : THROW_CCE());
  }
  vct(decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.tct();
    var composite = decoder.gcx(descriptor);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlinx.serialization.internal.KeyValueSerializer.deserialize.<anonymous>' call
      if (composite.rcw()) {
        var key = composite.acx(this.tct(), 0, this.dd2_1);
        var value = composite.acx(this.tct(), 1, this.ed2_1);
        tmp$ret$0 = this.cd2(key, value);
        break $l$block;
      }
      var key_0 = get_NULL();
      var value_0 = get_NULL();
      mainLoop: while (true) {
        var idx = composite.scw(this.tct());
        switch (idx) {
          case -1:
            break mainLoop;
          case 0:
            key_0 = composite.acx(this.tct(), 0, this.dd2_1);
            break;
          case 1:
            value_0 = composite.acx(this.tct(), 1, this.ed2_1);
            break;
          default:
            throw SerializationException.bcv('Invalid index: ' + idx);
        }
      }
      if (key_0 === get_NULL())
        throw SerializationException.bcv("Element 'key' is missing");
      if (value_0 === get_NULL())
        throw SerializationException.bcv("Element 'value' is missing");
      var tmp = (key_0 == null ? true : !(key_0 == null)) ? key_0 : THROW_CCE();
      tmp$ret$0 = this.cd2(tmp, (value_0 == null ? true : !(value_0 == null)) ? value_0 : THROW_CCE());
    }
    var result = tmp$ret$0;
    composite.qcw(descriptor);
    return result;
  }
}
class MapEntrySerializer extends KeyValueSerializer {
  constructor(keySerializer, valueSerializer) {
    super(keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.xd1_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  tct() {
    return this.xd1_1;
  }
  yd1(_this__u8e3s4) {
    return _this__u8e3s4.q1();
  }
  zd1(_this__u8e3s4) {
    return this.yd1((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  ad2(_this__u8e3s4) {
    return _this__u8e3s4.r1();
  }
  bd2(_this__u8e3s4) {
    return this.ad2((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  }
  cd2(key, value) {
    return new MapEntry(key, value);
  }
}
class SerializersModule {}
class SerialModuleImpl extends SerializersModule {
  constructor(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider) {
    super();
    this.gd2_1 = class2ContextualFactory;
    this.hd2_1 = polyBase2Serializers;
    this.id2_1 = polyBase2DefaultSerializerProvider;
    this.jd2_1 = polyBase2NamedSerializers;
    this.kd2_1 = polyBase2DefaultDeserializerProvider;
  }
  rcx(baseClass, value) {
    if (!baseClass.ze(value))
      return null;
    var tmp0_safe_receiver = this.hd2_1.c3(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c3(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.id2_1.c3(baseClass);
    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
  }
  qcx(baseClass, serializedClassName) {
    var tmp0_safe_receiver = this.jd2_1.c3(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).c3(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.kd2_1.c3(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  }
}
class SerializableWith {}
//endregion
function findPolymorphicSerializer(_this__u8e3s4, encoder, value) {
  var tmp0_elvis_lhs = _this__u8e3s4.wct(encoder, value);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered(getKClassFromExpression(value), _this__u8e3s4.xct());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function findPolymorphicSerializer_0(_this__u8e3s4, decoder, klassName) {
  var tmp0_elvis_lhs = _this__u8e3s4.yct(decoder, klassName);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throwSubtypeNotRegistered_0(klassName, _this__u8e3s4.xct());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    // Inline function 'kotlin.collections.iterator' call
    var tmp0_iterator = this$0.dcu_1.p1().a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'kotlinx.serialization.SealedClassSerializer.descriptor$delegate.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.component1' call
      var name = element.q1();
      // Inline function 'kotlin.collections.component2' call
      var serializer = element.r1();
      $this$buildSerialDescriptor.mcu(name, serializer.tct());
    }
    return Unit_instance;
  };
}
function SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.mcu('type', serializer(StringCompanionObject_instance).tct());
    var tmp = 'kotlinx.serialization.Sealed<' + this$0.zct_1.ye() + '>';
    var tmp_0 = CONTEXTUAL_getInstance();
    var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0));
    $this$buildSerialDescriptor.mcu('value', elementDescriptor);
    $this$buildSerialDescriptor.gcu_1 = this$0.acu_1;
    return Unit_instance;
  };
}
function SealedClassSerializer$descriptor$delegate$lambda($serialName, this$0) {
  return function () {
    var tmp = SEALED_getInstance();
    return buildSerialDescriptor($serialName, tmp, [], SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0));
  };
}
function descriptor$factory() {
  return getPropertyCallableRef('descriptor', 1, KProperty1, function (receiver) {
    return receiver.tct();
  }, null);
}
function init_kotlinx_serialization_SerializationException(_this__u8e3s4) {
  captureStack(_this__u8e3s4, _this__u8e3s4.zcu_1);
}
function serializer(_this__u8e3s4) {
  return StringSerializer_getInstance();
}
function serializer_0(_this__u8e3s4) {
  return ByteSerializer_getInstance();
}
function ByteArraySerializer_0() {
  return ByteArraySerializer_getInstance();
}
function MapEntrySerializer_0(keySerializer, valueSerializer) {
  return new MapEntrySerializer(keySerializer, valueSerializer);
}
function SetSerializer(elementSerializer) {
  return new LinkedHashSetSerializer(elementSerializer);
}
function get_elementDescriptors(_this__u8e3s4) {
  // Inline function 'kotlin.collections.Iterable' call
  return new _no_name_provided__qut3iv_0(_this__u8e3s4);
}
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!isBlank(serialName)) {
    // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException.l(toString(message));
  }
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.contracts.contract' call
  if (!!equals(kind, CLASS_getInstance())) {
    // Inline function 'kotlinx.serialization.descriptors.buildSerialDescriptor.<anonymous>' call
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException.l(toString(message_0));
  }
  var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
  builder(sdBuilder);
  return new SerialDescriptorImpl(serialName, kind, sdBuilder.hcu_1.e1(), toList(typeParameters), sdBuilder);
}
function _get__hashCode__tgwhef($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.ocw_1;
  _hashCode$factory();
  return this_0.r1();
}
function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.ncw_1);
  };
}
function SerialDescriptorImpl$toString$lambda(this$0) {
  return function (it) {
    return this$0.vcv(it) + ': ' + this$0.xcv(it).qcu();
  };
}
function buildSerialDescriptor$lambda($this$null) {
  return Unit_instance;
}
function _hashCode$factory() {
  return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
    return _get__hashCode__tgwhef(receiver);
  }, null);
}
var CONTEXTUAL_instance;
function CONTEXTUAL_getInstance() {
  if (CONTEXTUAL_instance === VOID)
    new CONTEXTUAL();
  return CONTEXTUAL_instance;
}
var BOOLEAN_instance;
function BOOLEAN_getInstance() {
  if (BOOLEAN_instance === VOID)
    new BOOLEAN();
  return BOOLEAN_instance;
}
var BYTE_instance;
function BYTE_getInstance() {
  if (BYTE_instance === VOID)
    new BYTE();
  return BYTE_instance;
}
var INT_instance;
function INT_getInstance() {
  if (INT_instance === VOID)
    new INT();
  return INT_instance;
}
var FLOAT_instance;
function FLOAT_getInstance() {
  if (FLOAT_instance === VOID)
    new FLOAT();
  return FLOAT_instance;
}
var STRING_instance;
function STRING_getInstance() {
  if (STRING_instance === VOID)
    new STRING();
  return STRING_instance;
}
var CLASS_instance;
function CLASS_getInstance() {
  if (CLASS_instance === VOID)
    new CLASS();
  return CLASS_instance;
}
var LIST_instance;
function LIST_getInstance() {
  if (LIST_instance === VOID)
    new LIST();
  return LIST_instance;
}
var MAP_instance;
function MAP_getInstance() {
  if (MAP_instance === VOID)
    new MAP();
  return MAP_instance;
}
var OBJECT_instance;
function OBJECT_getInstance() {
  if (OBJECT_instance === VOID)
    new OBJECT();
  return OBJECT_instance;
}
var SEALED_instance;
function SEALED_getInstance() {
  if (SEALED_instance === VOID)
    new SEALED();
  return SEALED_instance;
}
function decodeSequentially_0($this, compositeDecoder) {
  var klassName = compositeDecoder.ycw($this.tct(), 0);
  var serializer = findPolymorphicSerializer_0($this, compositeDecoder, klassName);
  return compositeDecoder.acx($this.tct(), 1, serializer);
}
function throwSubtypeNotRegistered(subClass, baseClass) {
  var tmp0_elvis_lhs = subClass.ye();
  throwSubtypeNotRegistered_0(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
}
function throwSubtypeNotRegistered_0(subClassName, baseClass) {
  var scope = "in the polymorphic scope of '" + baseClass.ye() + "'";
  throw SerializationException.bcv(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.ye() + "' has to be sealed and '@Serializable'."));
}
function readSize($this, decoder, builder) {
  var size = decoder.tcw($this.tct());
  $this.lcy(builder, size);
  return size;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function prepareHighMarksArray($this, elementsCount) {
  var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
  var elementsInLastSlot = elementsCount & 63;
  var highMarks = longArray(slotsCount);
  if (!(elementsInLastSlot === 0)) {
    highMarks[get_lastIndex(highMarks)] = (new Long(-1, -1)).c4(elementsCount);
  }
  return highMarks;
}
function markHigh($this, index) {
  var slot = (index >>> 6 | 0) - 1 | 0;
  var offsetInSlot = index & 63;
  $this.zcz_1[slot] = $this.zcz_1[slot].g4((new Long(1, 0)).c4(offsetInSlot));
}
function nextUnmarkedHighIndex($this) {
  var inductionVariable = 0;
  var last = $this.zcz_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var slot = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var slotOffset = imul(slot + 1 | 0, 64);
      var slotMarks = $this.zcz_1[slot];
      while (!slotMarks.equals(new Long(-1, -1))) {
        var indexInSlot = countTrailingZeroBits(slotMarks.b4());
        slotMarks = slotMarks.g4((new Long(1, 0)).c4(indexInSlot));
        var index = slotOffset + indexInSlot | 0;
        if ($this.xcz_1($this.wcz_1, index)) {
          $this.zcz_1[slot] = slotMarks;
          return index;
        }
      }
      $this.zcz_1[slot] = slotMarks;
    }
     while (inductionVariable <= last);
  return -1;
}
function get_EMPTY_DESCRIPTOR_ARRAY() {
  _init_properties_Platform_common_kt__3qzecs();
  return EMPTY_DESCRIPTOR_ARRAY;
}
var EMPTY_DESCRIPTOR_ARRAY;
function compactArray(_this__u8e3s4) {
  _init_properties_Platform_common_kt__3qzecs();
  // Inline function 'kotlin.takeUnless' call
  // Inline function 'kotlin.contracts.contract' call
  var tmp;
  // Inline function 'kotlinx.serialization.internal.compactArray.<anonymous>' call
  // Inline function 'kotlin.collections.isNullOrEmpty' call
  // Inline function 'kotlin.contracts.contract' call
  if (!(_this__u8e3s4 == null || _this__u8e3s4.g1())) {
    tmp = _this__u8e3s4;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.toTypedArray' call
    tmp_0 = copyToArray(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
}
var properties_initialized_Platform_common_kt_i7q4ty;
function _init_properties_Platform_common_kt__3qzecs() {
  if (!properties_initialized_Platform_common_kt_i7q4ty) {
    properties_initialized_Platform_common_kt_i7q4ty = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_DESCRIPTOR_ARRAY = [];
  }
}
function throwMissingFieldException(seen, goldenMask, descriptor) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var missingFields = ArrayList.h1();
  var missingFieldsBits = goldenMask & ~seen;
  var inductionVariable = 0;
  if (inductionVariable < 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!((missingFieldsBits & 1) === 0)) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element = descriptor.vcv(i);
        missingFields.h(element);
      }
      missingFieldsBits = missingFieldsBits >>> 1 | 0;
    }
     while (inductionVariable < 32);
  throw MissingFieldException.rcv(missingFields, descriptor.qcu());
}
function _get_childSerializers__7vnyfa($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.ld0_1;
  childSerializers$factory();
  return this_0.r1();
}
function _get__hashCode__tgwhef_0($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.nd0_1;
  _hashCode$factory_0();
  return this_0.r1();
}
function buildIndices($this) {
  var indices = HashMap.i8();
  var inductionVariable = 0;
  var last = $this.gd0_1.length - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.set' call
      var key = $this.gd0_1[i];
      indices.e3(key, i);
    }
     while (inductionVariable <= last);
  return indices;
}
function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.dd0_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.od0();
    return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
  };
}
function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
  return function () {
    var tmp0_safe_receiver = this$0.dd0_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.pd0();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(tmp1_safe_receiver.length);
      var inductionVariable = 0;
      var last = tmp1_safe_receiver.length;
      while (inductionVariable < last) {
        var item = tmp1_safe_receiver[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlinx.serialization.internal.PluginGeneratedSerialDescriptor.typeParameterDescriptors$delegate.<anonymous>.<anonymous>' call
        var tmp$ret$0 = item.tct();
        destination.h(tmp$ret$0);
      }
      tmp = destination;
    }
    return compactArray(tmp);
  };
}
function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
  return function () {
    return hashCodeImpl(this$0, this$0.qd0());
  };
}
function PluginGeneratedSerialDescriptor$toString$lambda(this$0) {
  return function (i) {
    return this$0.vcv(i) + ': ' + this$0.xcv(i).qcu();
  };
}
function hashCodeImpl(_this__u8e3s4, typeParams) {
  var result = getStringHashCode(_this__u8e3s4.qcu());
  result = imul(31, result) + contentHashCode(typeParams) | 0;
  var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator = 1;
  var tmp0_iterator = elementDescriptors.a1();
  while (tmp0_iterator.b1()) {
    var element = tmp0_iterator.c1();
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
    var hash = accumulator;
    var tmp = imul(31, hash);
    // Inline function 'kotlin.hashCode' call
    // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
    var tmp0_safe_receiver = element.qcu();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
  }
  var namesHash = accumulator;
  // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
  // Inline function 'kotlin.collections.fold' call
  var accumulator_0 = 1;
  var tmp0_iterator_0 = elementDescriptors.a1();
  while (tmp0_iterator_0.b1()) {
    var element_0 = tmp0_iterator_0.c1();
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy.<anonymous>' call
    var hash_0 = accumulator_0;
    var tmp_0 = imul(31, hash_0);
    // Inline function 'kotlin.hashCode' call
    // Inline function 'kotlinx.serialization.internal.hashCodeImpl.<anonymous>' call
    var tmp0_safe_receiver_0 = element_0.scv();
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
  }
  var kindHash = accumulator_0;
  result = imul(31, result) + namesHash | 0;
  result = imul(31, result) + kindHash | 0;
  return result;
}
function childSerializers$factory() {
  return getPropertyCallableRef('childSerializers', 1, KProperty1, function (receiver) {
    return _get_childSerializers__7vnyfa(receiver);
  }, null);
}
function typeParameterDescriptors$factory() {
  return getPropertyCallableRef('typeParameterDescriptors', 1, KProperty1, function (receiver) {
    return receiver.qd0();
  }, null);
}
function _hashCode$factory_0() {
  return getPropertyCallableRef('_hashCode', 1, KProperty1, function (receiver) {
    return _get__hashCode__tgwhef_0(receiver);
  }, null);
}
function get_EMPTY_SERIALIZER_ARRAY() {
  _init_properties_PluginHelperInterfaces_kt__xgvzfp();
  return EMPTY_SERIALIZER_ARRAY;
}
var EMPTY_SERIALIZER_ARRAY;
var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
  if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
    properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    EMPTY_SERIALIZER_ARRAY = [];
  }
}
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance === VOID)
    new ByteArraySerializer();
  return ByteArraySerializer_instance;
}
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance === VOID)
    new StringSerializer();
  return StringSerializer_instance;
}
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance === VOID)
    new FloatSerializer();
  return FloatSerializer_instance;
}
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance === VOID)
    new IntSerializer();
  return IntSerializer_instance;
}
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance === VOID)
    new ByteSerializer();
  return ByteSerializer_instance;
}
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance === VOID)
    new BooleanSerializer();
  return BooleanSerializer_instance;
}
function error($this) {
  throw IllegalStateException.w4('Primitive descriptor does not have elements');
}
function get_NULL() {
  _init_properties_Tuples_kt__dz0qyd();
  return NULL;
}
var NULL;
function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
  return function ($this$buildSerialDescriptor) {
    $this$buildSerialDescriptor.mcu('key', $keySerializer.tct());
    $this$buildSerialDescriptor.mcu('value', $valueSerializer.tct());
    return Unit_instance;
  };
}
var properties_initialized_Tuples_kt_3vs7ar;
function _init_properties_Tuples_kt__dz0qyd() {
  if (!properties_initialized_Tuples_kt_3vs7ar) {
    properties_initialized_Tuples_kt_3vs7ar = true;
    NULL = new Object();
  }
}
function get_EmptySerializersModuleLegacyJs() {
  _init_properties_SerializersModule_kt__u78ha3();
  return EmptySerializersModule;
}
var EmptySerializersModule;
var properties_initialized_SerializersModule_kt_fjigjn;
function _init_properties_SerializersModule_kt__u78ha3() {
  if (!properties_initialized_SerializersModule_kt_fjigjn) {
    properties_initialized_SerializersModule_kt_fjigjn = true;
    EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap());
  }
}
function EmptySerializersModule_0() {
  return get_EmptySerializersModuleLegacyJs();
}
function getChecked(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException.ce('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
function getChecked_0(_this__u8e3s4, index) {
  if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
    throw IndexOutOfBoundsException.ce('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
  return _this__u8e3s4[index];
}
//region block: post-declaration
initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
initMetadataForClass(_no_name_provided__qut3iv);
initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer');
initMetadataForClass(SerializationException, 'SerializationException', SerializationException.acv);
initMetadataForClass(UnknownFieldException, 'UnknownFieldException');
initMetadataForClass(MissingFieldException, 'MissingFieldException');
initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
initMetadataForClass(elementDescriptors$1);
initMetadataForClass(_no_name_provided__qut3iv_0, VOID, VOID, VOID, [Iterable]);
initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
protoOf(SerialDescriptorImpl).tcv = get_isNullable;
initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(SerialKind, 'SerialKind');
initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL');
initMetadataForClass(PrimitiveKind, 'PrimitiveKind');
initMetadataForObject(BOOLEAN, 'BOOLEAN');
initMetadataForObject(BYTE, 'BYTE');
initMetadataForObject(INT, 'INT');
initMetadataForObject(FLOAT, 'FLOAT');
initMetadataForObject(STRING, 'STRING');
initMetadataForClass(StructureKind, 'StructureKind');
initMetadataForObject(CLASS, 'CLASS');
initMetadataForObject(LIST, 'LIST');
initMetadataForObject(MAP, 'MAP');
initMetadataForObject(OBJECT, 'OBJECT');
initMetadataForClass(PolymorphicKind, 'PolymorphicKind');
initMetadataForObject(SEALED, 'SEALED');
initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
initMetadataForInterface(Encoder, 'Encoder');
initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
protoOf(ListLikeDescriptor).tcv = get_isNullable;
initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc');
initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc');
initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor');
initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer');
initMetadataForClass(CollectionSerializer, 'CollectionSerializer');
initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer');
initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer');
initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer');
initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer');
initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
initMetadataForCompanion(Companion);
initMetadataForClass(ElementMarker, 'ElementMarker');
protoOf(PluginGeneratedSerialDescriptor).tcv = get_isNullable;
initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ByteArraySerializer, 'ByteArraySerializer', VOID, VOID, [KSerializer, PrimitiveArraySerializer]);
initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder');
initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
protoOf(PrimitiveSerialDescriptor).tcv = get_isNullable;
initMetadataForClass(PrimitiveSerialDescriptor, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(MapEntrySerializer, 'MapEntrySerializer');
initMetadataForClass(SerializersModule, 'SerializersModule');
initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl');
initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
//endregion
//region block: exports
export {
  decodeSerializableElement$default as decodeSerializableElement$defaulthid1asndfp5l,
  STRING_getInstance as STRING_getInstance2md3nu8ka1da4,
  CLASS_getInstance as CLASS_getInstanceycyg9nehd7tt,
  LIST_getInstance as LIST_getInstance31r89469rgwkw,
  MAP_getInstance as MAP_getInstance242ky2ofgg8p5,
  OBJECT_getInstance as OBJECT_getInstanceoefnxtom5aro,
  BooleanSerializer_getInstance as BooleanSerializer_getInstance1a8uvzxl1s4k4,
  FloatSerializer_getInstance as FloatSerializer_getInstance3n1kixy3l1peh,
  IntSerializer_getInstance as IntSerializer_getInstance3jjhuzya8j8kz,
  StringSerializer_getInstance as StringSerializer_getInstance100dxy5jlaaom,
  ByteArraySerializer_0 as ByteArraySerializersn06x87bo7h0,
  MapEntrySerializer_0 as MapEntrySerializer3oe1sx5ozvw2u,
  SetSerializer as SetSerializert3lb0yy9iftr,
  PolymorphicKind as PolymorphicKindla9gurooefwb,
  PrimitiveKind as PrimitiveKindndgbuh6is7ze,
  decodeCollectionSize as decodeCollectionSize3l4gjp9ef5h8u,
  decodeSequentially as decodeSequentially27kmi8jnnsnbc,
  CompositeDecoder as CompositeDecoder2tzm7wpwkr0og,
  shouldEncodeElementDefault as shouldEncodeElementDefault1vy568gzcy4z0,
  CompositeEncoder as CompositeEncoderknecpkexzn3v,
  beginCollection as beginCollection27i47rk9upjw4,
  encodeSerializableValue as encodeSerializableValue1mu7jsn2oheqi,
  Encoder as Encoderqvmrpqtq8hnu,
  AbstractCollectionSerializer as AbstractCollectionSerializer32faixtbm1vtg,
  ArrayListSerializer as ArrayListSerializer7k5wnrulb3y6,
  ElementMarker as ElementMarker33ojvsajwmzts,
  typeParametersSerializers as typeParametersSerializers2likxjr48tr7y,
  GeneratedSerializer as GeneratedSerializer1f7t7hssdd2ws,
  MapLikeSerializer as MapLikeSerializer39txwolqjdcc2,
  PluginGeneratedSerialDescriptor as PluginGeneratedSerialDescriptorqdzeg5asqhfg,
  throwMissingFieldException as throwMissingFieldException2cmke0v3ynf14,
  EmptySerializersModule_0 as EmptySerializersModule991ju6pz9b79,
  DeserializationStrategy as DeserializationStrategy1z3z5pj9f7zc8,
  SealedClassSerializer as SealedClassSerializeriwipiibk55zc,
  SerializationException as SerializationExceptioneqrdve3ts2n9,
  SerializationStrategy as SerializationStrategyh6ouydnm6hci,
  UnknownFieldException as UnknownFieldExceptiona60e3a6v1xqo,
};
//endregion
